import React, { useState } from "react";

import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Btn } from "../../AbstractElements";

const SubmittedModal = (props) => {
  const [status, setStatus] = useState(
    props.currentStatus ? props.currentStatus : ""
  );
  
  return (
    <div>
      <Dialog
        open={props.isOpen}
        onClose={props.handleClose}

        // closeAfterTransition
        // slots={{ backdrop: Backdrop }}
        // slotProps={{
        //   backdrop: {
        //     timeout: 500,
        //   },
        // }}
      >
        <DialogTitle>
          {/* {props.data.message} */}
          {props.data.message}
        </DialogTitle>
        <DialogContent>
          <Typography>Action No: {props.data.actionNo}</Typography>
          <Typography>HR Control No: {props.data.hrControl}</Typography>
        </DialogContent>
        <DialogActions>
          <Btn attrBtn={{color:"primary", onClick:props.handleClose}}>OK</Btn>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default SubmittedModal;
